import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "dropdown" }
const _hoisted_4 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "sortDropdown"
}
const _hoisted_5 = {
  key: 0,
  class: "fas fa-check text-success small"
}
const _hoisted_6 = {
  key: 0,
  class: "fas fa-check text-success small"
}
const _hoisted_7 = {
  key: 0,
  class: "fas fa-check text-success small"
}
const _hoisted_8 = {
  key: 0,
  class: "fas fa-check text-success small"
}
const _hoisted_9 = { class: "card-body p-0" }
const _hoisted_10 = { class: "row g-0 h-100" }
const _hoisted_11 = { class: "col-12 col-md-6 border-end" }
const _hoisted_12 = { class: "d-flex align-items-center flex-grow-1 me-3" }
const _hoisted_13 = {
  class: "progress flex-grow-1",
  style: {"height":"6px"}
}
const _hoisted_14 = ["aria-valuenow"]
const _hoisted_15 = { class: "fw-bold text-muted small" }
const _hoisted_16 = { class: "col-12 col-md-6" }
const _hoisted_17 = { class: "d-flex align-items-center flex-grow-1 me-3" }
const _hoisted_18 = {
  class: "progress flex-grow-1",
  style: {"height":"6px"}
}
const _hoisted_19 = ["aria-valuenow"]
const _hoisted_20 = { class: "fw-bold text-muted small" }
const _hoisted_21 = {
  key: 0,
  class: "text-center p-3 text-muted small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "text-truncate mb-0" }, [
        _createElementVNode("i", { class: "fas fa-chart-pie fa-fw text-info" }),
        _createElementVNode("span", null, " Resumen Stakes")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("button", {
          class: "btn btn-sm btn-outline-secondary dropdown-toggle",
          type: "button",
          id: "sortDropdown",
          "data-bs-toggle": "dropdown",
          "aria-expanded": "false"
        }, [
          _createElementVNode("i", { class: "fas fa-sort me-1" })
        ], -1)),
        _createElementVNode("ul", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("li", null, [
            _createElementVNode("h6", { class: "dropdown-header" }, "Ordenar por")
          ], -1)),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "dropdown-item d-flex justify-content-between align-items-center",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSort('stake', 'desc')))
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "Mayor Stake", -1)),
              (_ctx.sortBy === 'stake' && _ctx.sortOrder === 'desc')
                ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "dropdown-item d-flex justify-content-between align-items-center",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSort('stake', 'asc')))
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "Menor Stake", -1)),
              (_ctx.sortBy === 'stake' && _ctx.sortOrder === 'asc')
                ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "dropdown-item d-flex justify-content-between align-items-center",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSort('count', 'desc')))
            }, [
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "Más Frecuentes", -1)),
              (_ctx.sortBy === 'count' && _ctx.sortOrder === 'desc')
                ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "dropdown-item d-flex justify-content-between align-items-center",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setSort('count', 'asc')))
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "Menos Frecuentes", -1)),
              (_ctx.sortBy === 'count' && _ctx.sortOrder === 'asc')
                ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leftColumnItems, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.stake,
              class: "d-flex align-items-center justify-content-between px-3 py-2"
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: "badge rounded-pill me-2",
                  style: _normalizeStyle({
                    backgroundColor: _ctx.getItemColor(item.stake),
                    color: '#fff',
                    minWidth: '3.5em',
                  })
                }, _toDisplayString(item.stake), 5),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: "progress-bar rounded",
                    role: "progressbar",
                    style: _normalizeStyle({
                      width: _ctx.getPercentage(item.count) + '%',
                      backgroundColor: _ctx.getItemColor(item.stake),
                    }),
                    "aria-valuenow": _ctx.getPercentage(item.count),
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, null, 12, _hoisted_14)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createTextVNode(_toDisplayString(item.count) + " ", 1),
                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-hashtag fa-xs ms-1 opacity-50" }, null, -1))
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rightColumnItems, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.stake,
              class: "d-flex align-items-center justify-content-between px-3 py-2"
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: "badge rounded-pill me-2",
                  style: _normalizeStyle({
                    backgroundColor: _ctx.getItemColor(item.stake),
                    color: '#fff',
                    minWidth: '3.5em',
                  })
                }, _toDisplayString(item.stake), 5),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", {
                    class: "progress-bar rounded",
                    role: "progressbar",
                    style: _normalizeStyle({
                      width: _ctx.getPercentage(item.count) + '%',
                      backgroundColor: _ctx.getItemColor(item.stake),
                    }),
                    "aria-valuenow": _ctx.getPercentage(item.count),
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, null, 12, _hoisted_19)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createTextVNode(_toDisplayString(item.count) + " ", 1),
                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-hashtag fa-xs ms-1 opacity-50" }, null, -1))
              ])
            ]))
          }), 128))
        ])
      ]),
      (_ctx.sortedStakes.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, " No hay datos de stakes "))
        : _createCommentVNode("", true)
    ])
  ]))
}